import {Nut_Settings_User} from 'nutshell-core/settings-constants';
import type {User} from 'nutshell-core/users/users-types';

import type {ContactPageFragment as Contact} from 'nutshell-graphql-types';

import {useActionBarFormTabSelection} from '../../../../core-entity/hooks/use-action-bar-form-tab-selection';
import {TAB_CALL} from '../../../../core-entity/redux/consts';
import {
    getTabOptions,
    useHandleCallClick,
    useOpenEmailModal,
    useOpenTextModal,
} from '../../../../core-entity/util/action-bar-helpers';
import {ActionBar as EntityActionBar} from '../../../../core-entity/workspace/action-bar';

type Props = {
    contact: Contact;
    user: User | null | undefined;
    getRef: (ref: HTMLDivElement | null) => void;
    hasScrolledPastCheckpoint: boolean;
};

export function ContactActionBar(props: Props) {
    const {actionBarTab, handleSelectFormTab} = useActionBarFormTabSelection(
        Nut_Settings_User.SETTING_CONTACT_PAGE_ACTION_BAR_TAB
    );

    const openEmailModal = useOpenEmailModal(props.contact);
    const {openTextModal, featureGate} = useOpenTextModal(props.contact, props.user);
    const {handleCallClick, popoverComponent} = useHandleCallClick(TAB_CALL, props.contact.id, {
        noPhoneNumbersQuestion: 'No phone numbers associated with this person',
    });

    return (
        <>
            <EntityActionBar
                options={getTabOptions(openEmailModal, openTextModal, handleCallClick)}
                selectedTab={actionBarTab}
                onSelectTab={handleSelectFormTab}
                getRef={props.getRef}
                entityDisplayName={props.contact.name}
                timelineEventFormProps={{
                    entityId: props.contact.id,
                    entityName: 'Contacts',
                    canOpen: !props.hasScrolledPastCheckpoint,
                }}
            />
            {featureGate}
            {popoverComponent}
        </>
    );
}
